/* <rr-recs> — pide las recomendaciones de Shopify al acercarse al viewport
   y las inyecta. Se piden antes de entrar en pantalla para que el relleno
   no provoque salto visible (CLS). Sin dependencias. */
(() => {
  if (customElements.get('rr-recs')) return;

  class RRRecs extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.dataset.loaded) return;

      const io = new IntersectionObserver(
        (entries, obs) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          obs.disconnect();
          this.load();
        },
        { rootMargin: '400px 0px' }
      );
      io.observe(this);
    }

    async load() {
      this.dataset.loaded = 'true';
      try {
        const res = await fetch(this.dataset.url);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('rr-recs');
        if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
      } catch {
        /* sin recomendaciones: la sección se queda vacía y no ocupa espacio */
      }
    }
  }

  customElements.define('rr-recs', RRRecs);
})();
